import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useSession } from './session-context';

// Route-level guard for the owner's pages (API-16; design `access()` for the team
// member, persona `xh-team`). A team member's session (active_role `staff`) reaches
// only Home, Bookings and Account; every other page reads merchant-only routes (403
// for staff), so a staff deep link lands on Home instead of mounting a screen whose
// reads the server refuses. Owners pass straight through. The rail, mobile bar and
// More sheet hide the same pages (nav-items.ts `staff`).
export function OwnerOnly({ children }: { children: ReactNode }) {
  const { isStaff } = useSession();
  if (isStaff) return <Navigate to="/" replace />;
  return <>{children}</>;
}
